import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDropdown } from "../../hooks/useDropdown";
// const SEARCH_REGEX = /^[0-9a-zA-Z_ -]*$/;

export const useSearchBar = () => {
  const [valid, setValid] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);

  const {
    elementRef,
    expanded: isAutoCompleteOpen,
    setExpanded: setIsAutoCompleteOpen,
  } = useDropdown();

  const navigate = useNavigate();

  const handleChange = (event) => {
    setSearchText(event.target.value);
    setIsSubmitted(false);
    const hasValue = !!event.target.value && !!event.target.value.trim();
    // const isValid = hasValue && SEARCH_REGEX.test(event.target.value);
    const isValid = hasValue;
    setValid(isValid);
    setIsAutoCompleteOpen(true);
  };

  const handleFocus = useCallback(() => {
    setIsAutoCompleteOpen(true);
  }, [setIsAutoCompleteOpen]);

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsSubmitted(true);
    if (searchText.length > 2) {
      navigate(`/search?keyword=${searchText}`);
      setIsAutoCompleteOpen(false);
    }
  };

  const handleClear = () => {
    setSearchText("");
  };

  return {
    containerRef: elementRef,
    handleChange,
    handleFocus,
    handleSubmit,
    isAutoCompleteOpen,
    setIsAutoCompleteOpen,
    valid,
    isSubmitted,
    searchText,
    handleClear,
  };
};
